module.exports = __webpack_public_path__ + "static/media/female_body.bcc2b9f5.png";